"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payment = void 0;
class Payment {
    constructor(props) {
        this.amount = props?.amount || null;
        this.consumed = {
            dt_closure: props?.consumed?.dt_closure,
            mpPlanId: props?.consumed?.mpPlanId,
            service_id: props?.consumed?.service_id,
        } || null;
        this.currency = props?.currency || null;
        this.dni = props?.dni || null;
        this.dt_payment = props?.dt_payment || null;
        this.fee = props?.fee || null;
        this.full_price = props.full_price || null;
        this.fullname = props?.fullname || null;
        this.gateway = props?.gateway || null;
        this.order_id = props?.order_id || null;
        this.payment = {
            card: props?.payment?.card,
            method: props?.payment?.method
        } || null;
        this.provider_uid = props?.provider_uid || null;
        this.quantity = props?.quantity || null;
        this.refund_reason = props?.refund_reason || null;
        this.service = props?.service || null;
        this.status = props?.status || null;
        this.statusDetail = props?.statusDetail || null;
        this.timestamps = {
            dt_payment: props?.timestamps?.dt_payment
        } || null;
        this.uid = props?.uid || null;
    }
}
exports.Payment = Payment;
